<iframe #iframe style="width: 100%; height: 800px"></iframe>

<!--<ng-container *ngTemplateOutlet="printContentTemplate"></ng-container>-->

<ng-template #printContentTemplate>
  <div class="document">
    <div class="page">
      <div class="header">
        <div class="logo">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 52">
            <g fill="#4E2C94">
              <path
                d="M27.7,13.6c0.1-5.8,0.1-9.1,0.1-10c0-0.5-0.3-1.1-0.9-1.8S25.7,0.7,25,0.4C24.8,0.1,24.2,0,23.4,0c-0.8,0-1.2,0.4-1.2,0.9c-0.7,8.3-1.4,14.7-2.2,19.1c-0.1-0.1-0.4-0.3-0.5-0.4c-1.6-1.4-3.5-2-5.4-2c-1.9-0.1-3.8,0.4-5.4,1.6c-2.6,1.9-4.7,4.5-6.2,7.9C1,30.5,0.1,33.9,0,37.3c-0.1,4.7,1.1,8.3,3.7,10.3c1.8,1.6,3.5,2.4,5.4,2.6c1.8,0.1,3.4-0.5,5.1-1.9c2.2-1.9,4.2-4.6,5.9-8.3c0.5-1.2,1.1-2.4,1.6-3.8c0,4.2,0.1,8,0.3,11.4c0,0.4,0.3,0.8,0.5,1.4c0.8,1.2,1.9,1.9,3.2,2.3c1.5,0.4,2.2,0,2.2-1.4c-0.3-13-0.4-20.8-0.4-23.2C27.6,23.6,27.6,19.3,27.7,13.6z M14.3,37.7c-1.5,3-3.2,5.2-5.1,6.4c-1.1,0.9-2,1.4-3,1.4C6,44.8,5.8,44.2,5.7,44c-0.5-2.4-0.5-5.3,0.1-8.1s1.9-5.6,3.4-7.9c2.3-3.5,4.6-5.4,6.9-5.7c0.5-0.1,0.9-0.1,1.4,0c0,0,0,0,0.1,0.1c0.3,0.1,0.4,0.3,0.5,0.5c0.4,0.5,0.7,1.1,0.9,1.9C17.9,29.7,16.2,33.9,14.3,37.7z"></path>
              <path
                d="M47.6,20.1c-2.6-2.6-5.4-3.9-8.8-4.2c-1.8-0.1-3.1,0-4.3,0.5c-0.9-0.3-1.5-0.1-1.8,0.4c-2.7,5.4-3.7,11.3-3.1,17.4c0.3,3.8,1.1,6.8,2.4,9.1c0.9,1.6,2,2.8,3.5,3.9c1.5,1.1,3.1,1.6,4.7,1.6c1.4,0,2.6-0.4,3.8-1.2c1.2-0.8,2.3-1.9,3.1-3.1c0.8-1.2,1.5-2.6,2-3.8c0.5-1.2,1.1-2.6,1.4-3.9c0.5-2,0.8-3.9,0.8-5.8s-0.3-3.9-0.9-5.8C49.9,23.2,49,21.4,47.6,20.1z M44.9,34.1c-0.5,1.9-1.5,3.8-2.7,5.7c-1.6,2.3-3,3.5-4.3,3.9c-0.1,0-0.3,0-0.7,0c-0.1-0.3-0.1-0.4-0.3-0.5c-0.1-0.3-0.3-0.8-0.5-1.5c-0.5-1.8-0.8-3.8-0.9-6.2c-0.3-4.9,0.5-9.6,2.7-14.2c0-0.1,0.1-0.3,0.1-0.4c0.3-0.1,0.5-0.3,0.9-0.3c0.8-0.1,1.6,0,2.4,0.1c0.7,0.1,1.2,0.4,1.8,0.7c0.3,0.1,0.4,0.1,0.5,0.3c0.3,0.3,0.4,0.4,0.5,0.7c0.8,1.2,1.2,3.1,1.2,5.7C45.7,29.9,45.4,31.9,44.9,34.1z"></path>
              <path
                d="M96,19.3c0,0-2-3.8-4.7-3.8c0,0-11.2,4.2-13.7,5.3c-2.4,1.1-1.6,2-1.1,3c0.5,0.9,1.5,2.7,2.7,2.3c1.2-0.3,6.4-2.6,6.4-2.6s-14.2,23.7-25,23.6c-0.4,0-1.8,0-2.4-3.4c-0.5-2.8-0.5-5.8,0-9.1c0.5,0.7,1.1,1.2,1.9,1.6c0.7,0.4,1.4,0.5,1.9,0.5c3.2-0.5,5.8-2.2,8.1-4.7c2.2-2.6,3.1-5.4,2.7-8.7c-0.1-1.4-0.5-2.6-1.2-3.7c-0.7-1.2-1.5-2.2-2.6-3c-1.1-0.8-2.3-1.4-3.5-1.5c-2.8-0.3-5.5,1.4-8.1,5.2c-1.9,2.7-3.2,5.8-4.2,9.1c-0.8,3.4-1.1,6.6-0.8,10c0.4,3.9,1.8,7.1,4.3,9.4c1.5,1.5,3.7,3.4,7.3,3.1c10.3-1.4,21.4-14,26.4-25.5c0,0-1.4,7.2-0.1,11.8c0,0,2.3,1.8,4.7,1.9C94.8,40.2,94.8,25,96,19.3zM60,28.6c1.1-2.4,2.6-4.6,4.1-6.2c1.8-1.8,2.7-1.8,2.7-1.8c0.4,1.6,0.3,3.3-0.4,4.7c-0.7,1.6-1.8,3-3.1,4.1c-1.4,1.1-2.8,1.9-4.3,2.3C59.4,30.5,59.6,29.6,60,28.6z"></path>
            </g>
          </svg>
        </div>
        <div class="vertrouwelijk">{{ 'PRINT_STARTCODES.CONFIDENTIAL' | translate | uppercase }}</div>
      </div>

      <div class="info">
        <h1>{{ 'PRINT_STARTCODES.INFO_HEADER' | translate }}</h1>
        <div class="divider"></div>
        <div class="url">{{ 'PRINT_STARTCODES.INFO_URL' | translate }}: <strong>toets.doe.nl</strong></div>
        <!--        <div class="unlock">{{'PRINT_STARTCODES.INFO_UNLOCK_CODE' | translate}}: <strong>734395</strong></div>-->
      </div>

      <div class="divider"></div>

      @if (deelnemers$ | async; as deelnemers) {
        <p-table
          [value]="deelnemers"
          scrollHeight="calc(100vh - 245px)"
          styleClass="p-datatable-sm"
          [multiSortMeta]="[
            { field: 'groep', order: 1 },
            { field: 'displayNaam', order: 1 },
          ]"
          sortMode="multiple"
          #printContentTable>
          <ng-template #header>
            <tr>
              <th>{{ 'PRINT_STARTCODES.TABLE_HEADERS.NAME' | translate }}</th>
              <th>{{ 'PRINT_STARTCODES.TABLE_HEADERS.GROUP' | translate }}</th>
              <th>{{ 'PRINT_STARTCODES.TABLE_HEADERS.TOETS' | translate }}</th>
              <th>{{ 'PRINT_STARTCODES.TABLE_HEADERS.STARTWOORD' | translate }}</th>
              <th>{{ 'PRINT_STARTCODES.TABLE_HEADERS.STARTCODE' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template #body let-deelnemer let-index="rowIndex">
            <tr>
              <td>{{ deelnemer.displayNaam }}</td>
              <td>{{ deelnemer.groep }}</td>
              <td>
                @if (deelnemer.planning?.toetsBusinessKey) {
                  {{
                    'TOETS_INFO.' +
                      removeCampaignSuffixFromBusinessKey(deelnemer?.planning?.toetsBusinessKey) +
                      '.LABEL' | translate
                  }}
                }
              </td>
              <td>{{ deelnemer.startcode?.startwoord }}</td>
              <td>{{ deelnemer.startcode?.startcode }}</td>
            </tr>
          </ng-template>
        </p-table>
      }
    </div>

    <div class="cards-container">
      @for (
        deelnemer of deelnemersWithStartcodeAndPlanning$ | async;
        track deelnemer;
        let idx = $index;
        let first = $first
      ) {
        <div class="card">
          <div class="name-group">
            <div>
              <strong>{{ deelnemer.displayNaam }}</strong>
            </div>
            <div>
              <strong>{{ deelnemer.afnamegroep?.groep }}</strong>
            </div>
          </div>
          <div>{{ 'PRINT_STARTCODES.INFO_URL' | translate }}: <strong>toets.doe.nl</strong></div>
          <div>
            {{ 'PRINT_STARTCODES.TABLE_HEADERS.STARTWOORD' | translate }}:
            <strong>{{ deelnemer.startcode?.startwoord }}</strong>
          </div>
          <div>
            {{ 'PRINT_STARTCODES.TABLE_HEADERS.STARTCODE' | translate }}:
            <strong>{{ deelnemer.startcode?.startcode }}</strong>
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>
